import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function customEmail({ client, config }: Context, parms: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/email/send', config.api.url);
  const { data: res } = await client.post(url.href, parms);
  // console.log('## 联系我们 ##================', res);
  return res;
}
